export default __webpack_public_path__ + "static/media/quatroOpen.0e1ad5dd.jpg";